import { TabPanel } from './tab-panel';

export { TabPanel };
